export { GlobalErrorView } from './src';
